/* esencja-nav r1 2026-10-20 */
class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    // aria-expanded in BEIDE richtingen: Dawn's close() zet hem alleen op false,
    // waardoor de summary na één keer sluiten permanent op false bleef staan.
    const summary = this.mainDetailsToggle.querySelector('summary');
    const open = this.mainDetailsToggle.open;
    if (summary) summary.setAttribute('aria-expanded', open ? 'true' : 'false');

    // Fallback voor browsers zonder ondersteuning van het name-attribuut op
    // <details>: zelf de andere panelen sluiten.
    if (open && !HeaderMenu.supportsName) {
      document.querySelectorAll('.header__inline-menu header-menu').forEach((other) => {
        if (other !== this) other.close();
      });
    }

    if (!this.header) return;
    this.header.preventHide = open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

// Ondersteunt deze browser <details name="...">? Zo ja, dan doet de browser het
// sluiten van de andere panelen zelf en hoeft de fallback hierboven niet.
HeaderMenu.supportsName = (() => {
  try {
    return 'name' in document.createElement('details');
  } catch (e) {
    return false;
  }
})();

customElements.define('header-menu', HeaderMenu);

// Sluiten bij klik buiten de navigatie en bij Escape. Eén listener op document,
// niet één per menu-item.
(() => {
  const sluitAlles = (zetFocusTerug) => {
    document.querySelectorAll('.header__inline-menu header-menu').forEach((menu) => {
      const details = menu.querySelector('details');
      if (!details || !details.open) return;
      if (zetFocusTerug) {
        const summary = details.querySelector('summary');
        if (summary) summary.focus();
      }
      menu.close();
    });
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('.header__inline-menu')) return;
    sluitAlles(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    sluitAlles(true);
  });
})();
